// Product minimum order quantity is currently stored as free text (for
// example, "100 kg"). Cart quantities are integer units, so use the first
// numeric amount as the minimum and round fractional values up.
export function minimumOrderQuantity(product) {
    const raw = String(product?.minOrderQty || '').match(/[\d,]+(?:\.\d+)?/)?.[0];
    const parsed = raw ? Number.parseFloat(raw.replace(/,/g, '')) : 1;
    return Math.max(1, Number.isFinite(parsed) ? Math.ceil(parsed) : 1);
}
